import {Avatar} from 'antd'
import classNames from 'classnames'
import {FollowButton} from 'components/Feed/FollowButton'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {nest} from 'recompose'
import {EntityContext, EntityProvider} from 'views/AppLocals/EntityList'
import {AppEntities} from 'views/AppLocals/enums'
import {ContextActionTypes, ItemContextMenu,} from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault, renderIf} from 'views/Shared'
import {renderIfElse} from '../../../Shared'
import {OverlayItemBanner} from '../../Templates/ItemTemplate'
import Translate from "../../../../modules/local/Translate";
import {PiArrowRightBold, PiGearSixFill} from "react-icons/pi";
import {HiOutlineLink} from "react-icons/hi2";
import {getEventTypeTitle} from "../../../Event/components/EventOverviewSetting";
import {ItemInfoWithIcon} from "../../Organization/OrganizationEntity";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {formatDate, parseDayjs} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import {BsFillCalendar2DateFill, BsPinMapFill} from "react-icons/bs";

export const EventCompactItem = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    return (
        <div className="relative w-full border border-color-50 rounded-lg background">
            <OverlayItemBanner type={AppEntities.EVENT}/>
            <div className="h-7"/>
            <div className="flex items-center px-3 py-2">
                {isSm ? null : (
                    <Avatar src={_.get(item, 'owner.avatar')}>
            <span className="capitalize text-color-100">
              {_.first(_.get(item, 'owner.title') || _.get(item, 'owner.name'))}
            </span>
                    </Avatar>
                )}
                <div className="flex-col flex-1 mx-3">
                    <Link
                        to={getLinkToDetail(item)}
                        className="cursor-pointer font-bold leading-tight max-lines-1">
                        {getTitle(item)}
                    </Link>
                    <span className="text-xs text-secondary italic leading-tight max-lines-1 mt-1">
            {_.get(item, 'owner.name') || _.get(item, 'owner.title')}
          </span>
                    <div className="flex items-center mt-2">
                        <div className="flex flex-col flex-1 mr-3">
                            <div className="flex space-x-1 text-xs italic">
                                <span className="text-color-400">{`${t('type of event')} :`}</span>
                                <span className="text-color-000 font-semibold">
                  {t(_.get(item, 'event_type'))}
                </span>
                            </div>
                            <div className="flex space-x-1 text-xs italic">
                                <span className="text-color-400">{`${t('expires')} :`}</span>
                                <span className="text-color-000 font-semibold">
                  {formatDate(_.get(item, 'time_open'),
                      'HH:MM - DD/MM/YYYY'
                  )}
                </span>
                            </div>
                        </div>
                        <FollowButton
                            size={isSm ? 'small' : 'default'}
                            item={item}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const ItemHeader = ({
                        impactCategories,
                        withMenuOptions = (item) =>
                            [
                                {
                                    key: ContextActionTypes.COPY,
                                    label: 'copy path',
                                    icon: <HiOutlineLink className="text-blue-500"/>,
                                },
                                !!_.get(item, 'edit', false)
                                    ? {
                                        icon: <PiGearSixFill className="text-color-400"/>,
                                        key: ContextActionTypes.SETTINGS,
                                        label: 'setting',
                                    }
                                    : undefined,
                            ].filter((e) => !_.isUndefined(e)),
                    }) => (
    <div className="absolute top-5 right-5 contextIcon">
        <EntityContext.Consumer>
            {({item, handleAction}) => (
                <ItemContextMenu
                    item={item}
                    onMenuSelect={handleAction}
                    items={withMenuOptions(item)}
                />
            )}
        </EntityContext.Consumer>
    </div>
)

const DefaultHyperLink = ({title, pathname, className, onClick = NullAsDefault}) => {
    const t = useTranslate()
    return (
        <Link
            to={pathname}
            onClick={onClick}
            className={classNames(
                'font-bold text-lg text-color-000 no-underline max-lines-1 leading-snug ',
                className
            )}>
            {t(title || 'no title')}
        </Link>
    )
}

export function renderIntervalWeekly(value) {
    let label = ''
    switch (value) {
        case '1000000':
            label = 'monday'
            break
        case '0100000':
            label = 'tuesday'
            break
        case '0010000':
            label = 'wednesday'
            break
        case '0001000':
            label = 'thursday'
            break
        case '0000100':
            label = 'friday'
            break
        case '0000010':
            label = 'saturday'
            break
        case '0000001':
            label = 'saturday'
            break
        default :
            label = null
            break
    }
    return label ? label : null
}

export function renderInterval(value, viewOnly = false) {
    let label
    switch (value) {
        case 'D':
            label = 'daily'
            break
        case 'W':
            label = 'weekly'
            break
        case 'M':
            label = 'monthly'
            break
        default :
            if (viewOnly) return "";
            label = 'do not repeat'
            break
    }
    return (
        <Translate>
            {(t) => t(label)}
        </Translate>
    )
}

const EventItem = ({item}) => {
    const t = useTranslate()
    const history = useHistory()
    const {isSm} = useContext(LayoutContext)

    const {time_open, time_close, location_name, description, external_link, event_type, interval_type, interval_daily, is_expired} = item ?? {}
    const openTime = time_open ? parseDayjs(time_open) : null;

    const renderLabelTime = (value) => {
        let label
        if (interval_type === 'D') {
            label = formatDate(value, 'HH:mm')
        } else if (interval_type === 'W') {
            label = [
                formatDate(value, 'HH:mm'),
                t(renderIntervalWeekly(interval_daily))
            ].join(' - ')
        } else if (interval_type === 'M') {
            label = [
                formatDate(value, 'HH:mm'),
                '-',
                t('date'),
                formatDate(value, 'DD')
            ].join(' ')
        } else {
            label = formatDate(value, 'DD MMMM, YYYY')
        }
        return (
            <span className="flex items-center gap-3">
                {label}
                {renderIf(
                    _.get(item, 'time_close'),
                    <span className="flex items-center font-semibold">
                        <PiArrowRightBold className="text-color-500 mr-2"/>
                        {formatDate(time_close, 'DD MMMM, YYYY')}
                    </span>
                )}
                {interval_type !== 'N' && (
                    <span className="ml-2 text-green-600 italic">
                        ( {renderInterval(interval_type, true)} )
                    </span>
                )}
            </span>
        )
    }

    return (
        <div className="px-3 py-2 border border-color-50 background shadow-md rounded-xl hover:scale-3xs custom-item-render relative">
            <div className="flex flex-col">
                <div className="mb-2 pb-2 border-b">
                    <DefaultHyperLink
                        title={getTitle(item)}
                        pathname={getLinkToDetail(item)}
                    />
                    <div className="flex items-center justify-between gap-3">
                        <span className="text-xs text-indigo-500 tracking-wider leading-snug italic">
                            {t(getEventTypeTitle(event_type))}
                        </span>
                        <div className="font-semibold text-xs italic ">
                            {is_expired === true ? (
                                <span className="text-red-600">{t('close')}</span>
                            ) : openTime && openTime.isValid() && openTime.isAfter(dayjs()) ? (
                                <span className="text-green-700">{t('upcoming')}</span>
                            ) : (
                                <span className="text-blue-700">{t('opening')}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex flex-col flex-1 gap-1">
                    {renderIf(
                        time_open,
                        <ItemInfoWithIcon
                            icon={<BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>}
                            value={renderLabelTime(time_open)}
                            className="flex items-center text-sm italic tracking-wide"/>
                    )}
                    {renderIfElse(
                        event_type === "webinar",
                        <ItemInfoWithIcon
                            icon={<BsPinMapFill size={12} className="mx-1 text-green-500"/>}
                            value={
                                <a href={external_link} target="_blank" className="no-underline">
                                    {external_link}
                                </a>
                            }
                            className="flex items-center text-sm italic tracking-wide"/>,
                        <ItemInfoWithIcon
                            icon={<BsPinMapFill size={12} className="mx-1 text-green-500"/>}
                            value={location_name}
                            className="flex items-center text-sm italic tracking-wide"
                        />
                    )}
                </div>
                <div className="mt-2 text-sm text-color-300 tracking-wider whitespace-pre-line">
                    {description}
                </div>
            </div>
            <ItemHeader/>
        </div>
    )
}

export default nest(EntityProvider, EventItem)
